import React, { useContext, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCheck, FiMail, FiX } from "react-icons/fi";
import "../css/paysuccess.css";
import { formatMoney } from "../utils/commerce";
import { CartContext } from "./CartContext";

function PaySuccess() {
  const location = useLocation();
  const { clearCart } = useContext(CartContext);
  const paymentState = new URLSearchParams(location.search).get("state") || "success";
  const successful = paymentState === "success";
  const order = useMemo(() => {
    if (location.state?.order) return location.state.order;
    try { return JSON.parse(window.localStorage.getItem("nartvmora-last-order") || "null"); }
    catch { return null; }
  }, [location.state]);

  useEffect(() => {
    if (successful) clearCart();
  }, [clearCart, successful]);

  return (
    <main className="success-page">
      <section className="success-card">
        <div className={`success-icon${successful ? "" : " is-cancelled"}`}>{successful ? <FiCheck aria-hidden="true" /> : <FiX aria-hidden="true" />}</div>
        <p className="eyebrow">{successful ? "Payment successful" : "Payment cancelled"}</p>
        <h1>{successful ? `Thank you${order?.customer ? `, ${order.customer.split(" ")[0]}` : ""}.` : "Your order was not charged."}</h1>
        <p className="success-lead">{successful ? "Your payment has been received and your order is being prepared." : "You can return to your bag and try again whenever you are ready."}</p>
        {successful && order && <dl className="success-details"><div><dt>Order</dt><dd>{order.number}</dd></div><div><dt>Items</dt><dd>{order.items}</dd></div><div><dt>Total</dt><dd>{formatMoney(order.total)}</dd></div><div><dt>Contact</dt><dd>{order.email}</dd></div></dl>}
        {successful && <div className="success-note"><FiMail /><p>An order confirmation will be sent to your checkout email with dispatch and tracking details.</p></div>}
        <div className="success-actions"><Link className="button button--dark" to={successful ? "/shop" : "/cart"}>{successful ? "Continue shopping" : "Return to bag"}</Link><Link to="/contact">Need help?</Link></div>
      </section>
    </main>
  );
}

export default PaySuccess;
